import React, { useRef } from "react";

import { Pill } from "src/base-components/Pill";
import { WorkspaceDataplane } from "src/clients/flow-api";
import { useWsInfoLazy } from "src/hooks/useWsInfoLazy";

export const WorkspaceVersionDisplay: React.FC<{
  workspace: WorkspaceDataplane;
}> = ({ workspace }) => {
  const wsRef = useRef<HTMLDivElement>(null);
  const { data: wsInfo, isLoading, error } = useWsInfoLazy(workspace, wsRef);

  const desiredVersion = workspace.flow_services_version;
  const actualVersion = wsInfo?.flow_services_version;

  // Check if versions match
  const versionsMatch = actualVersion && actualVersion === desiredVersion;
  const hasVersionMismatch = actualVersion && !versionsMatch;

  return (
    <div ref={wsRef} className="flex flex-row gap-1">
      <Pill variant="outlined-gray">
        <Pill.Text>
          <span className="font-inter-normal-12px text-gray-600">Desired:</span>{" "}
          {desiredVersion}
        </Pill.Text>
      </Pill>

      {isLoading && (
        <Pill variant="outlined-gray">
          <Pill.Text>
            <span className="font-inter-normal-12px text-gray-600">
              Actual:
            </span>{" "}
            Loading...
          </Pill.Text>
        </Pill>
      )}

      {error && (
        <Pill variant="red">
          <Pill.Text>
            <span className="font-inter-normal-12px text-gray-600">
              Actual:
            </span>{" "}
            Error
          </Pill.Text>
        </Pill>
      )}

      {actualVersion && (
        <Pill variant={hasVersionMismatch ? "yellow" : "outlined-gray"}>
          <Pill.Text>
            <span className="font-inter-normal-12px text-gray-600">
              Actual:
            </span>{" "}
            {actualVersion}
          </Pill.Text>
        </Pill>
      )}
    </div>
  );
};
